import { useEffect, useState } from "react";
import { Sheet, SheetContent } from "./ui/sheet";
import { Tabs, TabsContent, TabsList, TabsTrigger } from "./ui/tabs";
import { useData } from "../lib/DataContext";
import AdjustDialog from "./AdjustDialog";
import BomFlowchartModal from "./BomFlowchartModal";
import { usePolicy } from "./factsheet/common";
import FactSheetHeader from "./factsheet/FactSheetHeader";
import FactSheetMovementTab from "./factsheet/FactSheetMovementTab";
import FactSheetParamsTab from "./factsheet/FactSheetParamsTab";

export { usePolicy, bomUnitCost } from "./factsheet/common";

const tabCls = "h-10 data-[state=active]:bg-[#F59E0B] data-[state=active]:text-[#090D16]";

export default function ItemFactSheet({ itemId, onClose, onDuplicate }) {
  const { itemsById, refreshAll } = useData();
  const [adjust, setAdjust] = useState(false);
  const [cur, setCur] = useState(itemId);
  useEffect(() => { setCur(itemId); }, [itemId]);
  const it = itemsById[cur];
  return it ? <FactSheet key={it.id} it={it} onClose={onClose} adjust={adjust} setAdjust={setAdjust} refreshAll={refreshAll} onDuplicate={onDuplicate} onOpenItem={setCur} /> : null;
}

function FactSheet({ it, onClose, adjust, setAdjust, refreshAll, onDuplicate, onOpenItem }) {
  const pol = usePolicy(it);
  const [flow, setFlow] = useState(false);
  return (
    <Sheet open onOpenChange={(o) => !o && onClose()}>
      <SheetContent side="right" className="bg-[#0F1623] border-[#334155] w-full sm:max-w-xl overflow-y-auto" data-testid="item-fact-sheet">
        <FactSheetHeader it={it} pol={pol} onFlow={() => setFlow(true)} onDuplicate={onDuplicate} />
        <Tabs defaultValue="movement">
          <TabsList className="grid grid-cols-2 h-12 bg-[#090D16] mb-4">
            <TabsTrigger value="movement" data-testid="fact-tab-movement" className={tabCls}>Inventory & Movement</TabsTrigger>
            <TabsTrigger value="params" data-testid="fact-tab-params" className={tabCls}>Material Data</TabsTrigger>
          </TabsList>
          <TabsContent value="movement"><FactSheetMovementTab it={it} onAdjust={() => setAdjust(true)} /></TabsContent>
          <TabsContent value="params"><FactSheetParamsTab it={it} pol={pol} onSaved={refreshAll} onDeleted={() => { onClose(); refreshAll(); }} /></TabsContent>
        </Tabs>
        <AdjustDialog item={adjust ? it : null} onClose={() => setAdjust(false)} />
        <BomFlowchartModal item={flow ? it : null} onClose={() => setFlow(false)} onOpenItem={(id) => { setFlow(false); onOpenItem(id); }} />
      </SheetContent>
    </Sheet>
  );
}
